import { lazy } from "react";

const TableManagementListing = lazy(() => import("./pages/tables-listing"))

export const basePath = "/app/dashboard/table-management/"

export const TableManagementPaths = {
    tableManagement: basePath ,
}

export const TableManagementBreadcrumbs = {
    tableManagement: {
        href: TableManagementPaths.tableManagement,
        label: "Table Management"
    }
}

const TableManagementRoutes = [
    {
        path: TableManagementPaths.tableManagement,
        component: TableManagementListing
    }
]
export default TableManagementRoutes